/*
 * @Descripttion: 数字翻牌器弹框配置
 * @Author: shenah
 * @Date: 2023-07-07 09:34:36
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:36:18
 */
export const createWholeConfig = () => {
  return {
    fontSize: 32, // 字号
    color: "#FFFFFF", // 字体颜色
    fontBgColor: null, // 字体背景色
    isFontBold: false, // 字体是否加粗
    digitalFont: false, // 是否是液晶字体
    fontMargin: [0, 0, 0, 0], // 字体外边距
    fontPadding: [5, 10, 5, 10], // 字体内边距
    align: "center", // 对齐方式
    isTotalDigital: false, //整体
    singleBackgroundConfig: {}, // 单个背景图
    decimals: 0, // 小数位数
    isShowZero: true, // 小数位数是否显示0
    unitTransform: "",
    separator: "", // 分割符,
    config: {
      duration: 3000, // 滚动时间
      autoplay: true, // 是否自动滚动
      useEasing: true,
      easingFn: function (t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
      },
    },
  };
};
export const extendsAttrs = Object.keys(createWholeConfig());
